// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallDownLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ArrowSmallDownLeftIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M13 13H7V7h1.5v4.5H13z" />
      <path d="m7.5 11.5 4.243-4.243 1.06 1.061-4.242 4.243z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallDownLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallDownLeftIconComponent,
  { displayName: 'ArrowSmallDownLeftIcon' },
);
